/* eslint new-cap: ['error', { 'capIsNew': false }]*/
import { Map, fromJS } from 'immutable';
import { RestAPI } from '@/util/net.js';
import { putError } from '@/store/error.store';

export const locksReducer = (state = Map(), action) => {
  switch (action.type) {
    case 'DEAL_LOCKED': {
      const lock = action.lock;
      return state.set(lock.entityType,
        state.get(lock.entityType, new Map()).set(lock.entityId, fromJS(lock)));
    }
    case 'DEAL_UNLOCKED': {
      const lock = action.lock;
      return state.deleteIn([lock.entityType, lock.entityId]);
    }
    case 'LOCKS_LOADED':
      return fromJS(action.locks) || new Map();
    default:
      return state;
  }
};

export const lockEntity = (dispatch, entity) => {
  dispatch({ type: 'BEGIN_LOCKING' });
  return RestAPI.post('/collaboration/api/locks/lock', entity)
    .then(
      () => true
    ).catch(
      (data) => {
        // если конфликт, то все ок
        if (data.status != 409) {
          putError(dispatch, data);
          dispatch({ type: 'LOCKING_FAILED' });
        }
        return true;
      }
    );
};

export const unlockEntity = (dispatch, entity) => {
  dispatch({ type: 'BEGIN_UNLOCKING' });
  return RestAPI.post('/collaboration/api/locks/unlock', entity)
    .then(
      () => true
    ).catch(
      (data) => {
        // если конфликт, то все ок
        if (data.status != 409) {
          putError(dispatch, data);
          dispatch({ type: 'UNLOCKING_FAILED' });
        }
        return true;
      }
    );
};
export const unlockDeal = (dispatch, dealType, dealId) => {
  dispatch({ type: 'BEGIN_UNLOCKING' });
  return RestAPI.post(`/collaboration/api/locks/unlockdeal/${dealType}/${dealId}`)
    .then(
      () => true
    ).catch(
      (data) => {
        // если конфликт, то все ок
        if (data.status != 409) {
          putError(dispatch, data);
          dispatch({ type: 'UNLOCKING_FAILED' });
        }
        return true;
      }
    );
};
export const takeLock = (dispatch, dealType, dealId) => {
  dispatch({ type: 'BEGIN_TAKING_LOCK' });
  return RestAPI.post(`/collaboration/api/locks/takelock/${dealType}/${dealId}`)
    .then(
      () => true
    ).catch(
      (data) => {
        // если конфликт, то все ок
        if (data.status != 409) {
          putError(dispatch, data);
          dispatch({ type: 'TAKING_LOCK_FAILED' });
        }
        return true;
      }
    );
};
export const loadAllLocks = (dispatch, currentUserId) => {
  dispatch({ type: 'BEGIN_LOCKS_LOADING' });
  return RestAPI.get('/collaboration/api/locks')
    .then(
      (locks) => {
        dispatch({ type: 'LOCKS_LOADED', currentUserId, locks });
        return true;
      }
    ).catch(
      (data) => {
        // если конфликт, то все ок
        if (data.status != 409) {
          putError(dispatch, data);
          dispatch({ type: 'LOCKS_LOADING_FAILED' });
        }
        return true;
      }
    );
};
